import { ArrowDown, CalendarDays, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import heroImage from '@/assets/hero-nairobi.jpg';

const STATS = [
  { value: '2 days', label: 'of building' },
  { value: '100+', label: 'women builders' },
  { value: '2.1M', label: 'sats in prizes' },
  { value: '₿ + Nostr', label: 'mentors on site' },
];

export function Hero() {
  return (
    <section id="top" className="relative isolate flex min-h-svh flex-col overflow-hidden bg-accent">
      {/* Background photo + warm overlays */}
      <img
        src={heroImage}
        alt="The Nairobi skyline at dusk, glowing with city lights"
        className="absolute inset-0 -z-20 size-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#1c0e26]/80 via-[#2a1230]/35 to-[#1c0e26]/90" />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_center,transparent_0%,rgba(28,14,38,0.35)_100%)]" />
      <div className="absolute inset-0 -z-10 bg-primary/15 mix-blend-overlay" />

      {/* Content */}
      <div className="container flex flex-1 flex-col items-center justify-center gap-8 pb-16 pt-32 text-center text-white">
        <div className="flex flex-wrap items-center justify-center gap-2 text-sm font-medium">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 backdrop-blur-sm">
            <CalendarDays className="size-4 text-primary" aria-hidden />
            14–15 November 2026
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 backdrop-blur-sm">
            <MapPin className="size-4 text-primary" aria-hidden />
            Nairobi, Kenya
          </span>
        </div>

        <div className="max-w-4xl space-y-6">
          <p className="text-sm font-semibold uppercase tracking-[0.35em] text-primary">
            SheSats Nairobi
          </p>
          <h1 className="font-display text-5xl font-semibold leading-[1.05] tracking-tight text-balance sm:text-6xl lg:text-7xl">
            The future of money is{' '}
            <em className="text-primary not-italic underline decoration-wavy decoration-2 underline-offset-8">hers</em>{' '}
            to build.
          </h1>
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-white/85 sm:text-xl">
            A two-day Bitcoin &amp; Nostr hackathon for women. Learn from the best,
            build with sats, and ship something real — no experience needed.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Button
            asChild
            size="lg"
            className="h-12 rounded-full px-8 text-base font-semibold shadow-lg shadow-primary/30"
          >
            <a href="#rsvp">Save your spot</a>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="h-12 rounded-full border-white/30 bg-white/5 px-8 text-base font-semibold text-white backdrop-blur-sm hover:bg-white/15 hover:text-white"
          >
            <a href="#about">Explore the weekend</a>
          </Button>
        </div>

        <a
          href="#about"
          aria-label="Scroll to learn more"
          className="mt-4 rounded-full p-2 text-white/60 transition-colors hover:text-white motion-safe:animate-bounce"
        >
          <ArrowDown className="size-5" />
        </a>
      </div>

      {/* Stats strip */}
      <div className="relative border-t border-white/15 bg-[#1c0e26]/60 backdrop-blur-md">
        <dl className="container grid grid-cols-2 gap-y-6 py-6 text-white md:grid-cols-4">
          {STATS.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1 text-center">
              <dt className="order-2 text-xs font-medium uppercase tracking-widest text-white/60">
                {stat.label}
              </dt>
              <dd className="order-1 font-display text-2xl font-semibold text-primary sm:text-3xl">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
